module.exports = __webpack_public_path__ + "static/img/8.53aced51.png";